<template>
  <div class="u-editor">
    <slot></slot>
    <script
      class="editor"
      ref="editor"
      type="text/plain"
      style="width: 100%; height: 100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;"
    />
    <slot name="foot"></slot>
  </div>
</template>

<script>
/* eslint-disable */
import "../assets/uEditor/ueditor.config";
import "../assets/uEditor/ueditor.all";
import "../assets/uEditor/lang/zh-cn/zh-cn";
import "../assets/uEditor/ueditor.parse";

export default {
  name: "UE",
  data() {
    return {
      editor: null,
      id:
        Math.random()
          .toString(16)
          .substring(2) + "ueditorId"
    };
  },
  props: {
    defaultMsg: {
      type: String
    },
    config: {
      type: Object,
      default() {
        return {
          initialFrameHeight: 800,
          topOffset: 46
        };
      }
    },
    value: {
      type: String
    }
  },
  methods: {
    getUEContent() {
      // 获取内容方法
      return this.editor.getContent();
    },
    setUEContent(html) {
      this.editor.setContent(html);
    }
  },
  destroyed() {
    this.editor.destroy();
  },
  mounted() {
    const _this = this;
    this.$refs.editor.id = this.id;
    this.editor = UE.getEditor(this.id, this.config); // 初始化UE
    this.editor.addListener("ready", function(editor) {
      console.log(_this);
      _this.$root.eventBus.$emit("ue-ready");
    });
    this.editor.addListener("contentChange", function(editor) {
      _this.$emit("input", _this.editor.getContent());
    });
  }
};
</script>

<style scoped>
.u-editor {
  padding: 30px 10px;
  overflow: hidden;
  box-sizing: border-box;
}
</style>

<style lang="scss">
.edui-editor-iframeholder {
  min-height: 600px;
  background-color: #ccc;
  text-align: center;
  iframe {
    box-sizing: border-box;
    width: 25cm;
    margin: 0 auto;
    padding: 0 1cm;
    background-color: #fff;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/uEditor.vue